var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('Carousel'),_c('MainPage',{on:{"clickNew":_vm.scrollToBenefit}}),_c('Benefit',{ref:"refBenefit",attrs:{"id":"benefit"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }